import filterByKeywords from './filterByKeywords'

export default (searchedByKeyword, filters, agenda, covenant, level, user) => {
  filterByKeywords(searchedByKeyword, filters, agenda)
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/tags/resources/filters/index.js